import {
    DELETE_WISH_LIST_GROUP_START,
    DELETE_WISH_LIST_GROUP_SUCCESS,
    DELETE_WISH_LIST_GROUP_ERROR,
    CLOSE_DELETE_WISHLIST_MODAL
} from '../../constants';
import history from '../../core/history';
import getAllWishListGroupQuery from '../../components/WishLists/getAllWishListGroup.graphql';
import { deleteWishListGroup as mutation } from '../../lib/graphql';

export function deleteWishListGroup(
    id
) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: DELETE_WISH_LIST_GROUP_START,
            });

            let profileId = getState().account.data.profileId;

            const { data } = await client.mutate({
                mutation,
                variables: {
                    id: id
                },
                refetchQueries: [
                    {
                        query: getAllWishListGroupQuery,
                        variables: {
                            profileId
                        }
                    }
                ]
            });
            if (data?.DeleteWishListGroup?.status == 'success') {
                history.push('/wishlists');
            }

            dispatch({
                type: DELETE_WISH_LIST_GROUP_SUCCESS,
            });
            dispatch({
                type: CLOSE_DELETE_WISHLIST_MODAL,
                deleteModalOpen: false,
            });
        } catch (error) {
            dispatch({
                type: DELETE_WISH_LIST_GROUP_ERROR,
                payload: {
                    error
                }
            });
            dispatch({
                type: CLOSE_DELETE_WISHLIST_MODAL,
                deleteModalOpen: false,
            });
            return false;
        }
        return true;
    };
}